// extracted by mini-css-extract-plugin
export default {"title":"nilai-transaksi-properti_title__RMe8z","required":"nilai-transaksi-properti_required__xWCJi","shadow":"nilai-transaksi-properti_shadow__cqrwF"};